'use client';
import { useAuthStore, useGlobalStore } from '@/slw/shared/stores';
import { FooterBanner, HeroBanner, ImageTextSection, ValuesSectionContent, WhoWeAreSection } from '@/slw/widgets/about';
import { Breadcrumb } from '@/slw/widgets/common/breadcrumb.ui';
export function AboutUsPage() {
  const breadcrumbs = [{ name: 'About Us' }];
  const { user } = useAuthStore();
  const { openAuthModal } = useGlobalStore();

  return (
    <main className='container mb-20'>
      <Breadcrumb data={breadcrumbs} />

      <div className='mx-auto mb-8'>
        <h1 className='text-[1.5rem] md:text-[2.5rem] lg:text-[4rem] mb-8 font-bold text-foreground leading-[120%]'>
          About ClovisClassics.com
        </h1>
      </div>
      <HeroBanner />
      <WhoWeAreSection />
      <section className=''>
        <h2 className='text-2xl md:text-4xl text-center font-bold text-primary pb-8 md:pb-16'>Our mission</h2>
        <ImageTextSection
          heading='We Build Brands That Move People'
          headingColor='#C8932B'
          text='We build brands that move people. ClovisClassics is dedicated 
          to elevating the classic car experience for 
          everyone—buyers, sellers, and dreamers alike. Our mission is 
          to unite, empower, and inspire through a shared love of automotive history.'
          image='/images/about-us/about-car.png'
          imageAlt='Our mission'
          imageLeft={false}
          ctaLabel='Become Part of the Story'
          ctaHref='/search-results/all-year'
        />
        <ImageTextSection
          heading='We Unite Classic Car Enthusiasts'
          headingColor='#C8932B'
          text='Our platform brings together collectors, restorers, and fans from around the world. 
          Join our vibrant community, share your stories, and celebrate the passion for classic cars.'
          image='/images/about-us/about-car2.png'
          imageAlt='Unite Enthusiasts'
          imageLeft={true}
          ctaLabel='Join our community'
          ctaHref={user?.id ? '/' : ''}
          onCtaClick={openAuthModal}
        />
        <ImageTextSection
          heading='We Empower Sellers'
          headingColor='#C8932B'
          text='ClovisClassics empowers sellers by providing premium tools for listing, exposure, and 
          connecting with genuine buyers. 
          Get the best value for your vehicle with our trusted process.'
          image='/images/about-us/about-car4.png'
          imageAlt='Empower Sellers'
          imageLeft={false}
          ctaLabel='Get a slot for your vehicle!'
          ctaHref='/sell-your-car'
        />
      </section>
      <ValuesSectionContent />
      {/* Detailed Values Section (expanded, animated) can be added here if needed */}
      {/* <CTASection /> */}
      <FooterBanner />
    </main>
  );
}
